//Articles Template

//Key "graphic" looking within the images folder
//Example of graphicReposition = 50% 40%; this is optional

const articleMusicVideo = {
    "key": "wATCh",
    "title": "Original Animated Music Video",
    "skills": "Design | Animation | Video Editing",
    "date": "2022 - 2023",
    "path": "music-video",
    "graphic": "animation/testChamber_cover.jpg",
    "graphicReposition": "",
    "content": [
      {
        "component": "Title",
        "content": "Original Animated Music Video"
      },
      {
        "component": "Subheading",
        "design": "centered",
        "content": "Design | Animation | Video Editing"
      },
      {
        "component": "Body",
        "design": "full-width centered",
        "content": "Inspired by my son's love for robots and music videos by Hirokazu Tanaka, I created this fully-animated music video to accompany one of my original tracks called \"Test&nbsp;Chamber&nbsp;0\"."
      },
      {
        "component": "YoutubeEmbed",
        "embedId": "jy516hErmtg"
      },
      {
        "component": "Body",
        "design": "full-width centered caption",
        "content": "\"Test Chamber 0\" was recorded using hardware synths and mixed in Ableton Live.<br/>Music was completed first before working on supporting animations."
      },
      {
        "component": "Subheading",
        "content": "Creating this video involved the following:",
        "design": "centered"
      },
      {
        "component": "List",
        "listType": "unordered",
        "content": [
          "Establish a visual identity for the video",
          "Conceptualize visual components and scenes",
          "Determine frame requirements for each segment",
          "Draw sequences",
          "Develop tools for streamlining the animation process",
          "Beat sync video to audio track"
        ]
      },
      {
        "component": "Heading",
        "content": "Getting Started"
      },
      {
        "component": "Subheading",
        "content": "Paper & Pencil"
      },
      {
        "component": "Image",
        "alt": "hand-drawn robot sketches while coming up with ideas",
        "source": "animation/handdrawn-robots.jpg"
      },
      {
        "component": "Body",
        "content": "I was inspired to make a music video with dancing robots shortly after sketching some for my boy from a book we had read together. He instantly recognized that I was drawing \"wobots\", which made me want to make something extra special for him! I took one of the characters we had made and turned him into the center piece of this work."
      },
      {
        "component": "Body",
        "content": "[Preface] I believe it is important to point out that the animations seen below were created from still frames drawn in Photoshop, exported to video or GIF files. They were intially drawn at 240 x 135 and later upscaled to 1920 x 1080 for Youtube."
      },
      {
        "component": "Combination",
        "design": "image",
        "source": "animation/robot1.gif",
        "title": "Robot 1",
        "content": "Robot 1 was born out of the repetitive bass line of my music track. This character established the visual identity for the video. The jagged low-bit design became a feature of all the animated components moving forward. The snappy movement would be iconic, memorable, and feasible for a single animator to carry across the finish line.",
        "caption": "The sequence has 8 frames. The first 3 are reused for 5-7. Only 5 images in total are required for the loop. This is similar to 8-bit game development, where memory limitations encourages designers to think creatively to solve design challenges."
      },
      {
        "component": "Combination",
        "source": "animation/science-tube-animation.gif",
        "title": "Science and Math",
        "content": "What goes better with robots than science experiments? The test tube animation became a test for myself on my animation skills 😜. I focused attention on \"realistic\" liquid movements and the seamlessness of the&nbsp;loop.",
        "caption": "I actually had to draw this animation twice. My earlier version had 13 frames. But, in order to make the animation sync better with the beats of the music, I decided to make it into an 8-frame loop. This gave me the opportunity to improve the water ripple effects in the secondpass."
      },
      {
        "component": "Heading",
        "content": "The \"Why\""
      },
      {
        "component": "Subheading",
        "content": "Incoherent to Purposeful"
      },
      {
        "component": "Body",
        "content": "\"Test Chamber 0\" may have just started as a fun personal project, meant to entertain family members and engage subscribers. But it brought to light one thing that bothers me about the music scene I'm into. Most electronic dance music performers put on big expensive lightshows that are mostly incoherent. These shows certainly have that \"coolness factor,\" but they rarely go well with the actual music. It's almost like someone else other than the artist determined the lights and has no idea what was going to happen during the&nbsp;show."
      },
      {
        "component": "Image",
        "source": "animation/pexels-deane-bayas-9534913_min.jpg",
        "alt": "Lightshows in electronic dance music are often too much and undeceficerable by the audience"
      },
      {
        "component": "Body",
        "content": "I want to break that cycle by building strong sensory connections between the visual experience and the music. This sort of approach takes into consideration the whole user experience rather than piecemealing together resources that don't really jive. Yes, this takes a lot more work than outsourcing your lights and visuals to a third party, but I believe the value is there. People will come to appreciate the standard of work and the attention to&nbsp;detail!"
      },
      {
        "component": "Heading",
        "content": "Bringing It Together"
      },
      {
        "component": "Subheading",
        "content": "Brute Force Creativity"
      },
      {
        "component": "Body",
        "content": "No one ever said forming new and unique content was easy. Sometimes, creative tasks like animation just require some straightforward hard work and dedication to carry across the finish line. Such was the case in this project."
      },
      {
        "component": "Body",
        "content": "Transforming the consumption method of \"Test Chamber 0\" from audio only to audio + video took some serious work and passion. Many hours were spent just listening to my track over and over again in the car on the way to work and thinking through the image sequences, and visualizing what might happen at any given moment in the music."
      },
      {
        "component": "Body",
        "content": "Other times, new ideas would come during the editing or animating process, while splicing parts together, or after exporting comps. Working on the video iteratively like this would reveal gaps so that the next time I was just listening to the track, I could think about what might fill it. That's where the second robot, the drag-and-drop robot builder GUI, and nervous scientist came in."
      },
      {
        "component": "Image",
        "source": "animation/video-comps.jpg",
        "alt": "picture of the various exported files generated during the making of Test Chamber 0 music video"
      },
      {
        "component": "Body",
        "design": "caption centered",
        "content": "I would export early versions of the project before it was fully complete, allowing me to identify opportunities for improvements and gaps in the timeline. I also pre-rendered segments of the video before bringing the sections together in my master timeline in order to save on render times and computer processing."
      },
      {
        "component": "Heading",
        "content": "Conclusion"
      },
      {
        "component": "Body",
        "content": "I was really happy with the final product, and I felt I learned a lot. I learned it would have been a little easier to work with song tempos that are easily divisible by 30 or 60! I also learned that you can do anything if you put your mind to it and work hard. I learned the importance of planning and storyboarding. I believe that if I were to do another video like this, I would spend even more time in the prep phase. There were 2 animations I completed that never made it into the final cut. I also spent time developing an animation tool I ended up abandoning in favor of doing each frame by hand; the results were better in the long run! Also, don't put the word \"Test\" in the title of something; people won't click it on Youtube."
      },
      {
        "component": "Body",
        "content": "I have many ideas for future animation projects like this one. Hoping to try 3D animation at some point and also some more complex video effects. Here's to an exciting future making more videos and \"testing\" out new ideas!"
      }
    ]
}

export default articleMusicVideo;